import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import type { DashboardPluginConfig } from '@wix/cli-app-definitions';
import { getDashboardPluginsDir } from '@wix/cli-app-definitions';
import type { ImportData } from '@wix/extensions-data-client';

// NOTE: path is relative to the build folder
const DASHBOARD_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/dashboard-plugin'
);

export async function generateDashboardPlugin(
  projectFolder: string,
  extended: string,
  folder: string,
  title: string,
  importData?: ImportData
) {
  const cwd = path.join(getDashboardPluginsDir(projectFolder), folder);
  const pluginConfig: DashboardPluginConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/dashboard-plugin.json',
    id: randomUUID(),
    title,
    extends: extended,
  };
  const pluginConfigJSON = toJsonString(pluginConfig, { spaces: 2 });

  return await componentGenerator({
    template: DASHBOARD_PLUGIN_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      pluginConfigJSON,
      importData,
    },
    importData,
  });
}
